const MODERN_PAGES_PANEL_HOSTS = new Set(['EDITOR3', 'STUDIO2']);

export const isEditor3 = () => {
  // @ts-expect-error
  return self?.commonConfig?.host === 'EDITOR3';
};

export const isModernPagesPanelEditor = () => {
  // @ts-expect-error
  return MODERN_PAGES_PANEL_HOSTS.has(self?.commonConfig?.host ?? '');
};
